import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';

/**
 * Texto "Expira en …" de una oferta en el idioma activo, o null si ya venció.
 * Usa días, luego horas y, en la última hora, minutos (una oferta con 45 min
 * restantes sigue vigente). Usa la forma singular cuando el número es 1.
 */
export const dealExpirationLabel = (
  translate: TranslateService,
  endsAt: string,
  now: moment.Moment = moment(),
): string | null => {
  const target = moment(endsAt);
  const units: ['days' | 'hours' | 'minutes', string][] = [
    ['days', 'day'],
    ['hours', 'hour'],
    ['minutes', 'minute'],
  ];

  for (const [unit, singular] of units) {
    const count = target.diff(now, unit);
    if (count > 0) {
      const key = count === 1 ? `deals.deal.expires_in_${singular}` : `deals.deal.expires_in_${unit}`;
      return translate.instant(key, { count });
    }
  }

  return null;
};
